import { useCurrentUser } from '@/modules/authentification/hooks';
import Layout from '@/modules/layout/Layout';
import { menuAdminItems } from '@/modules/layout/constants/ConstantsAdminMenu';

export function AdminLayout() {
  const { user } = useCurrentUser();
  const userRoles = user?.roles || [];
  return <Layout itemsMenu={menuAdminItems(userRoles)} />;
}
